import { Col } from "reactstrap";
import { OrderByButton } from "../common/components/multiselectablelist/OrderByButton";
import { FilterHeader } from "../common/components/multiselectablelist/FilterHeader";
import { CyFilterHeader } from "../common/components/multiselectablelist/CyFilterHeader";
import { Column } from "../common/components/multiselectablelist/Column";
import React from "react";
import { MultiChangeToolbar } from "./MultiChangeToolbar";
import { DeletableEntry } from "../common/components/multiselectablelist/DeleteEntriesModal";

interface Props<E extends DeletableEntry> {
  filterableColumn: Column<E>;
  additionalColumns: Column<E>[];
  changeOrderBy: (newField: keyof E) => void;
  orderByAscOrDesc: "asc" | "desc";
  orderByField: keyof E;
  searchTerm: string | undefined;
  setSearchTerm: (searchTerm: string | undefined) => void;
  selectedEntries: readonly E[];
  bucket: string;
  reexecuteQuery?: () => void;
}

export function ItemsHeaderColumns<E extends DeletableEntry>({
  filterableColumn,
  additionalColumns,
  changeOrderBy,
  orderByAscOrDesc,
  orderByField,
  searchTerm,
  setSearchTerm,
  selectedEntries,
  bucket,
  reexecuteQuery,
}: Props<E>) {
  const button: React.JSX.Element = (
    <OrderByButton
      title={filterableColumn.title}
      field={filterableColumn.field}
      changeOrderBy={changeOrderBy}
      currentField={orderByField}
      currentOrder={orderByAscOrDesc}
      dataCy={CyFilterHeader.ButtonOrderBy}
    />
  );

  return (
    <>
      <Col xs={12} lg={8}>
        {/*We don't remove the element but only hide it to not lose he state when it's not visible.*/}
        <FilterHeader
          column={filterableColumn}
          searchTerm={searchTerm}
          orderByButton={button}
          setSearchTerm={setSearchTerm}
          visible={selectedEntries.length === 0}
        />
        {selectedEntries.length > 0 && (
          <MultiChangeToolbar<E>
            selectedEntries={selectedEntries}
            bucket={bucket}
            reexecuteQuery={reexecuteQuery}
          />
        )}
      </Col>
      {additionalColumns.map((column) => (
        <Col key={String(column.field)} className="d-none d-lg-block" lg={2}>
          <OrderByButton
            title={column.title}
            field={column.field}
            changeOrderBy={changeOrderBy}
            currentField={orderByField}
            currentOrder={orderByAscOrDesc}
          />
        </Col>
      ))}
    </>
  );
}
